import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions,
} from '@material-ui/core';
import React, { memo } from 'react';
import ModalCloseButton from 'components/modal-close-button';
import { ConfirmationDialogProps } from './confirmation-dialog-props';
import './confirmation-dialog.scss';
/**
 * A dialog component to ask for user confirmation
 */
export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = memo((props) => {
  const {
    title,
    confirmLabel,
    cancelLabel,
    open,
    onConfirm,
    onCancel,
  } = props;

  return (
    <>
      <Dialog
        open={open}
        onClose={onCancel}
        fullWidth
        maxWidth="sm"
      >
        <div className="sg-confirmation-dialog">
          <DialogTitle className="sg-confirmation-dialog__title">
            {title}
          </DialogTitle>
          <ModalCloseButton onClose={onCancel} />
          <DialogContent>
            {props.children}
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => onCancel()}
            >
              {cancelLabel}
            </Button>
            <Button
              onClick={() => onConfirm()}
            >
              {confirmLabel}
            </Button>
          </DialogActions>

        </div>
      </Dialog>
    </>
  );
});
